import { type FormEvent, useState } from "react";
import styles from "./SearchBar.module.css";

type Props = {
  initial?: string;
  onSubmit: (q: string) => void;
  compact?: boolean;
  large?: boolean;
};

export default function SearchBar({
  initial = "",
  onSubmit,
  compact = false,
  large = false,
}: Props) {
  const [q, setQ] = useState(initial);

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    const trimmed = q.trim();
    if (!trimmed) return;
    onSubmit(trimmed);
  }

  const cls = [styles.form, compact && styles.compact, large && styles.large]
    .filter(Boolean)
    .join(" ");

  return (
    <form className={cls} onSubmit={handleSubmit} role="search">
      {compact ? (
        // Compact (header): the magnifying glass IS the submit button.
        <button
          type="submit"
          className={styles.iconSubmit}
          aria-label="Search"
        >
          ⌕
        </button>
      ) : (
        // Large/default: leading icon is decorative; the pink button submits.
        <span className={styles.icon} aria-hidden>
          ⌕
        </span>
      )}
      <input
        type="search"
        className={styles.input}
        placeholder={
          large
            ? "Search artists, teams, events, venues..."
            : "Search events..."
        }
        value={q}
        onChange={(e) => setQ(e.target.value)}
      />
      {!compact && (
        <button type="submit" className={styles.btn} aria-label="Search">
          <span className={styles.btnText}>Search</span>
          <span className={styles.btnIcon} aria-hidden>
            →
          </span>
        </button>
      )}
    </form>
  );
}
